import type { ReactElement } from "react";
import { Table } from "@circle-react-uikit/TableV2";
import { useDataTableDataProvider } from "../Provider/DataTableDataProvider";
import { Head } from "./Head";

export interface HeaderProps {
  className?: string;
  isSticky?: boolean;
  renderHeader?: (props: { header: any }) => ReactElement;
}

export const Header = ({
  isSticky = true,
  className,
  renderHeader,
}: HeaderProps) => {
  const { table } = useDataTableDataProvider();
  const headerGroups = table.getHeaderGroups();

  return (
    <Table.TableHead isSticky={isSticky} className={className}>
      {headerGroups.map(headerGroup => (
        <Table.Tr key={headerGroup.id}>
          {headerGroup.headers.map(header => (
            <Head key={header.id} header={header} renderHeader={renderHeader} />
          ))}
        </Table.Tr>
      ))}
    </Table.TableHead>
  );
};
